var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllustrationWomanBc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 86.758,
    height: 78.137,
    viewBox: "0 0 86.758 78.137",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Illustration_-_01",
    "data-name": "Illustration - 01",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1714",
    "data-name": "Path 1714",
    d: "M85.647,87.4c-15.3,0-27.259,7.634-31.176,19.026s3.609,32.425,22.794,34.314,29.39-13.4,48.391-10.857,18.083-19.5,4.924-28.936S100.949,87.4,85.647,87.4Z",
    transform: "translate(-53.466 -87.403)",
    fill: "#e3f1dc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1715",
    "data-name": "Path 1715",
    d: "M200.689,347.568a33.111,33.111,0,0,1,4.4,14.44l-28,.077s.68-9.853,4.258-12.791Z",
    transform: "translate(-146.858 -283.947)",
    fill: "#548943",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1716",
    "data-name": "Path 1716",
    d: "M204.448,159.157c2.973-2.357,3.558-5.439,2.782-8.845s-3.581-7.807-3.709-9.324c-.252-2.99.09-4.3-2.137-6.956s-7.313-2.381-9.573-1.026-3.6,3.145-3.6,6.838-4.824,6.611-3.453,13.847a9.578,9.578,0,0,0,9.434,7.861C200.026,161.552,201.723,161.317,204.448,159.157Z",
    transform: "translate(-152.468 -121.094)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1717",
    "data-name": "Path 1717",
    d: "M214.957,210.486c3.958,0,5.09-4.234,5.09-4.234s-2.007-.726-2.221-1.552a56.352,56.352,0,0,1-.188-5.642l-5.721-.122a42.6,42.6,0,0,1-.2,5.693c-.283.917-2.113,1.581-2.113,1.581S211,210.486,214.957,210.486Z",
    transform: "translate(-171.421 -171.662)",
    fill: "#ffc8c7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3411",
    "data-name": "Group 3411",
    transform: "translate(38.963 27.587)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1718",
    "data-name": "Path 1718",
    d: "M220.334,201.432a9.268,9.268,0,0,1-7.537,5.093l1.072-6.31Z",
    transform: "translate(-212.797 -200.215)",
    fill: "#f2aaa9",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1719",
    "data-name": "Path 1719",
    d: "M203.811,154.619a23.3,23.3,0,0,1-.964,3.422,5.706,5.706,0,0,0-.292.969l.009.135a.985.985,0,0,0-1.1.3c-.472.568.242,2.3,1.314,2.545a.549.549,0,0,0,.07.011,8.131,8.131,0,0,0,2,4.584c2.523,3.157,4.874,3.149,7.363.339l.168-.189c.9-1.007,1.63-1.822,1.945-4.758,1.044-.281,1.729-1.973,1.264-2.533a.985.985,0,0,0-1.105-.3c0-.01,0-.02,0-.029,0-.214-.28-.872-1.316-1.092a7.989,7.989,0,0,0-1.041-.113,15.8,15.8,0,0,1-5.024-1.085A7.776,7.776,0,0,1,203.811,154.619Z",
    transform: "translate(-165.157 -138.182)",
    fill: "#ffc8c7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3412",
    "data-name": "Group 3412",
    transform: "translate(36.736 21.493)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1720",
    "data-name": "Path 1720",
    d: "M255.3,177.019s-.457.174-.55-.16a14.9,14.9,0,0,1-.183-1.562l-.184,2.6Z",
    transform: "translate(-241.99 -175.297)",
    fill: "#f2aaa9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1721",
    "data-name": "Path 1721",
    d: "M203.69,177.086s.457.174.55-.16.348-1.629.348-1.629l.059,2.622Z",
    transform: "translate(-203.69 -175.297)",
    fill: "#f2aaa9",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1722",
    "data-name": "Path 1722",
    d: "M226.917,175.221a15.084,15.084,0,0,1-.2,3.82,1.478,1.478,0,0,0,2.154,0",
    transform: "translate(-184.353 -153.746)",
    fill: "none",
    stroke: "#181b32",
    strokeWidth: 0.553
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1723",
    "data-name": "Path 1723",
    d: "M223.76,197.991h3.524s-.838,1.118-1.762,1.118S223.76,197.991,223.76,197.991Z",
    transform: "translate(-182.116 -170.948)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1724",
    "data-name": "Path 1724",
    d: "M215.458,169.005a2.667,2.667,0,0,1,1.131-.251,2.593,2.593,0,0,1,1.144.193c.206.118.324.265.2.438s-.364,0-.5-.073a1.834,1.834,0,0,0-.87-.214,3.439,3.439,0,0,0-.995.141c-.211.068-.354.173-.409.073S215.287,169.094,215.458,169.005Z",
    transform: "translate(-175.617 -148.86)",
    fill: "#181b32",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1725",
    "data-name": "Path 1725",
    d: "M219.444,177.072a.4.4,0,1,0-.4-.4A.4.4,0,0,0,219.444,177.072Z",
    transform: "translate(-178.551 -154.534)",
    fill: "#181b32",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1726",
    "data-name": "Path 1726",
    d: "M238.32,177.072a.4.4,0,1,0-.4-.4A.4.4,0,0,0,238.32,177.072Z",
    transform: "translate(-192.811 -154.534)",
    fill: "#181b32",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1727",
    "data-name": "Path 1727",
    d: "M236.56,169.005a2.665,2.665,0,0,0-1.13-.251,2.593,2.593,0,0,0-1.144.193c-.206.118-.324.265-.2.438s.364,0,.5-.073a1.833,1.833,0,0,1,.87-.214,3.441,3.441,0,0,1,.995.141c.211.068.354.173.409.073S236.731,169.094,236.56,169.005Z",
    transform: "translate(-189.877 -148.86)",
    fill: "#181b32",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1728",
    "data-name": "Path 1728",
    d: "M214.993,174.774a1.617,1.617,0,1,0-1.616-1.617A1.616,1.616,0,0,0,214.993,174.774Z",
    transform: "translate(-174.272 -150.965)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.553,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1729",
    "data-name": "Path 1729",
    d: "M234.813,174.774a1.617,1.617,0,1,0-1.616-1.617A1.616,1.616,0,0,0,234.813,174.774Z",
    transform: "translate(-189.246 -150.965)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.553,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1730",
    "data-name": "Path 1730",
    d: "M226.591,177.375a1.759,1.759,0,0,1,1.615.058",
    transform: "translate(-184.255 -155.241)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.553
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1731",
    "data-name": "Path 1731",
    d: "M246.41,173.837l2.228-1.4",
    transform: "translate(-199.228 -151.645)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.553
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1732",
    "data-name": "Path 1732",
    d: "M207.736,173.776l-1.8-1.34",
    transform: "translate(-168.652 -151.642)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.553
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1733",
    "data-name": "Path 1733",
    d: "M203.823,175.13s-.575-.131-.675.381.675,1.37.675,1.37",
    transform: "translate(-166.538 -153.666)",
    fill: "none",
    stroke: "#f2aaa9",
    strokeWidth: 0.553
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1734",
    "data-name": "Path 1734",
    d: "M255.98,175.13s.575-.131.675.381-.675,1.37-.675,1.37",
    transform: "translate(-206.457 -153.666)",
    fill: "none",
    stroke: "#f2aaa9",
    strokeWidth: 0.553
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1735",
    "data-name": "Path 1735",
    d: "M148.273,225.568c-5.564-.2-9.234.054-12.371,1.02s-14.592,18.278-14.563,18.259,6.377,1.832,6.377,1.832l8.635-10.567,2.879,20.968s10.878,3.893,19.342-1.726c0,0-.629-14.372,1.457-17.669L172.81,248.54s-8.551-14.567-6.376-15.953c0,0-5.931-4.392-8.277-5.2A27.386,27.386,0,0,0,148.273,225.568Z",
    transform: "translate(-104.74 -191.733)",
    fill: "#faad14",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1740",
    "data-name": "Path 1740",
    d: "M264.973,192.256a.475.475,0,0,0-.385.644l.525,1.347a.253.253,0,0,0,.043.073,9.159,9.159,0,0,0,2.215,1.948,12.773,12.773,0,0,0,2.745,2.234c1.2.584,2.9,3.576,2.9,3.576s4.468,14.353,9.063,15.105,4.595-6.123-1.234-11.7-5.469-6.138-6.5-8.446-1.649-4.024-1.159-4.7c.409-.568,1.462-1.79,1.8-2.175a.932.932,0,0,0,.162-.266l.889-2.227a.512.512,0,0,0-.305-.672h0a.522.522,0,0,0-.636.256,11.182,11.182,0,0,1-2.072,3.075l.257-2.339a3.8,3.8,0,0,0-.018-.975l-.473-3.187a.532.532,0,0,0-.6-.449h0a.532.532,0,0,0-.461.554l.151,2.983a3.757,3.757,0,0,1-.12,1.151l-.2.742-.143-.879a3.619,3.619,0,0,0-.542-1.4l-1.733-2.654a.511.511,0,0,0-.716-.143h0a.511.511,0,0,0-.172.645l1.219,2.513a3.748,3.748,0,0,1,.376,1.635v1.8l-.41-.234a3.948,3.948,0,0,0-3.544-.188l-.543.238a.69.69,0,0,0-.339.323l-.425.85a.514.514,0,0,0,.409.741h0a.578.578,0,0,0,.5-.215,2.374,2.374,0,0,1,2.093-1.024,1.925,1.925,0,0,1,1.687,2.029,1.347,1.347,0,0,1-2.151,1.129,3.64,3.64,0,0,1-1.57-1.385.618.618,0,0,0-.583-.327Z",
    transform: "translate(-212.922 -159.899)",
    fill: "#ffc8c7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3414",
    "data-name": "Group 3414",
    transform: "translate(56.38 38.284)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1741",
    "data-name": "Path 1741",
    d: "M298.952,259.158a44.611,44.611,0,0,1,2.43,5.239,13.784,13.784,0,0,0,2.2,4.624",
    transform: "translate(-295.301 -255.441)",
    fill: "none",
    stroke: "#f49394",
    strokeWidth: 0.553
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1742",
    "data-name": "Path 1742",
    d: "M284.023,243.959a2.609,2.609,0,0,0,2.567.54",
    transform: "translate(-284.023 -243.959)",
    fill: "none",
    stroke: "#f49394",
    strokeWidth: 0.553
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1743",
    "data-name": "Path 1743",
    d: "M120.277,304.677a2.467,2.467,0,0,0-.525,2.609c.453,1.632,4.179,5.528,7.474,8.871,2.528,2.565,4.645,4.932,5.791,4.932,2.64,0,1.924-.965,3.437-.517l2.6,1.032a.477.477,0,0,0,.587-.2h0a.477.477,0,0,0-.159-.646l-2.548-1.588a.344.344,0,0,1-.126-.446h0a.345.345,0,0,1,.381-.183l1.307.28a2.061,2.061,0,0,1,.475.164l2.6,1.27a.494.494,0,0,0,.62-.158h0a.5.5,0,0,0-.149-.71l-2.815-1.689a3.535,3.535,0,0,0-1.341-.471l-.339-.046.56-.016a3.536,3.536,0,0,1,1.718.391l2.061,1.06a.459.459,0,0,0,.544-.093h0a.459.459,0,0,0-.068-.688l-2.392-1.7a3.022,3.022,0,0,0-1.458-.546l-.556-.055,1.4-.213a.314.314,0,0,1,.167.02l1.784.743a.421.421,0,0,0,.364-.019h0a.393.393,0,0,0,.061-.663,6.645,6.645,0,0,0-2.711-1.328,3.918,3.918,0,0,0-3.115.818c-.62.491-2.2,2-3.555.886-.685-.562-2.381-3.528-4.532-6.688a20.2,20.2,0,0,0-2.005-2.314l.1-.1.277-.266S120.277,304.641,120.277,304.677Z",
    transform: "translate(-103.42 -251.544)",
    fill: "#ffc8c7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3415",
    "data-name": "Group 3415",
    transform: "translate(19.148 54.86)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1744",
    "data-name": "Path 1744",
    d: "M131.767,312.092a4.257,4.257,0,0,1,3.411,0",
    transform: "translate(-131.767 -311.745)",
    fill: "none",
    stroke: "#f49394",
    strokeWidth: 0.553
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationWomanBc);
export default __webpack_public_path__ + "static/media/Illustration-woman-bc.a7f1406a6a39d57ac38f359d1c69f1f1.svg";
export { ForwardRef as ReactComponent };